import * as React from 'react';
import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import my_profile from '../../../../assets/images/my_profile.png';
import useClickOutside from '../../../../Hooks/useClickOutside';
import { PostGrid } from '../../../../Components/PostGrid/PostGrid';
import { useDropzone } from 'react-dropzone';
import videoPlayerImage from '../../../../assets/images/videoPlayer.png';
import { GlobalUncContext } from '../../../../Components/Layout/Layout';


export interface IEditPostProps {
    setShowEditModal: any,
    showEditModal: any,
    editModalRef: any,
}

export function EditPost({ showEditModal, setShowEditModal, editModalRef, }: IEditPostProps) {
    const { postDatas, setPostDatas, } = React.useContext(GlobalUncContext)
    const [editPostData, setEditPostData] = useState(postDatas.find((post: any) => post.id === showEditModal.postID));

    const [postVisibilityDropOpen, setPostVisibilityDropOpen] = React.useState(false)
    const [postVisibilityText, setPostVisibilityText] = React.useState('Public');
    let postVisibilityRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(postVisibilityRef, () => setPostVisibilityDropOpen(false))
    // console.log(editPostData.postImages);



    const autoIncraseHeight = (e: any) => {
        e.target.style.height = "1px";
        e.target.style.height = (e.target.scrollHeight) + "px";
    }

    const [isPhotoVideoOpen, setIsPhotoVideoOpen] = useState(false)
    const [isChangeInputFontSize, setIsChangeInputFontSize] = useState(false)
    const [createPostInputText, setCreatePostInputText] = useState('')

    const handleCreatePostInputOnChange = (e: any) => {
        setCreatePostInputText(e.target.value)
        autoIncraseHeight(e)

        if (e.target.value.length > 120) {
            setIsChangeInputFontSize(true)
        } else {
            setIsChangeInputFontSize(false)
            if (isPhotoVideoOpen) {
                setIsChangeInputFontSize(true)
            }
        }
    }
    useEffect(() => {
        if (isPhotoVideoOpen) {
            setIsChangeInputFontSize(true)
        }
    }, [isPhotoVideoOpen])







    const [uploadedImageFile, setUploadedImageFile] = useState<any>(null);
    const { getRootProps, getInputProps, fileRejections, acceptedFiles } = useDropzone({
        // accept: 'image/*',
        accept: 'image/*,video/mp4',
        // maxFiles: 1,
        multiple: true,
        onDrop: acceptedFiles => {
            const acceptedFileWithPreviewSrc = acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            }))

            const previewURLs: any = [];

            acceptedFileWithPreviewSrc.map(file => {
                if (file.type === 'video/mp4') {
                    // getVideoCover(file.preview, 2)
                    previewURLs.push({
                        source: videoPlayerImage,
                        videoSrc: file.preview,
                        isVideoPlayOnPost: true,
                        isVideo: true,
                        id: previewURLs.length + 1,
                    })
                } else {
                    previewURLs.push({ source: file.preview, id: previewURLs.length + 1 })
                }
            })

            setUploadedImageFile(previewURLs)
        }
    })
    useEffect(() => {
        const commentWriteInput = document.getElementById("writeCommentBoxInput") as HTMLInputElement;
        commentWriteInput.style.height = (commentWriteInput.scrollHeight) + "px";
        setCreatePostInputText(commentWriteInput.value)

        if (!showEditModal.isOpen) {
            setUploadedImageFile(null)
        }
        if (editPostData.postImages) {
            setUploadedImageFile(editPostData.postImages)
            setIsPhotoVideoOpen(true)
        }


    }, [showEditModal.isOpen])



    const [postType, setPostType] = useState<any>(editPostData.postType)
    // post submit
    const hanldePostEditSubmit = () => {
        const commentWriteInput = document.getElementById("writeCommentBoxInput") as HTMLInputElement;
        const prevPostDatas = [...postDatas]

        const updatedPostData = prevPostDatas.find((post: any) => post.id === showEditModal.postID)
        updatedPostData.postType = postType;
        updatedPostData.whoCanSee = postVisibilityText;
        updatedPostData.postText = commentWriteInput!.value;
        updatedPostData.postImages = uploadedImageFile ? uploadedImageFile : [];

        // const newPost = {
        //     id: postDatas.length + 1,
        //     name: 'Donald Trump',
        //     isMyPost: true,
        //     postType: postType,
        //     postProfilePhoto: my_profile,
        //     minsAgo: todayDateAndTime,
        //     whoCanSee: postVisibilityText,
        //     postText: commentWriteInput!.value,
        //     postImages: uploadedImageFile ? uploadedImageFile : [],  
        //     profilePhoto: my_profile,
        //     comments: [],
        //     loves: 0,
        //     isMyloves: false,
        //     shares: 0,
        // }




        if (commentWriteInput!.value.length > 1) {
            setPostDatas(prevPostDatas)
            setShowEditModal({ isOpen: false, postID: -1 })
            setCreatePostInputText('')
        } else {
            if (uploadedImageFile) {
                setPostDatas(prevPostDatas)
                setShowEditModal({ isOpen: false, postID: -1 })
                setCreatePostInputText('')
            } else {
                return
            }
        }
    }


















    // create post uploded images preview
    const [windowWidth, setWindowWidth] = useState(1920)

    useEffect(() => {
        setWindowWidth(window.innerWidth);

    }, [])

    const getImageData = (clickedImageSource?: any, clickedRootData?: any) => {
        // console.log(clickedImageSource);
        // console.log(clickedRootData);
    }

    const getPostGridPorps = (images: any, rootData: any) => {
        let heightNumber = [260, 220]

        if (images.length >= 5) {
            heightNumber = windowWidth > 640 ? [300, 240] : [120, 110]
        }
        else if (images.length === 1) {
            heightNumber = windowWidth > 640 ? [348] : [170]
        }
        else if (images.length === 2) {
            heightNumber = windowWidth > 640 ? [360] : [170]
        }
        else if (images.length === 3) {
            heightNumber = windowWidth > 640 ? [340, 240] : [170, 110]
        }
        else if (images.length === 4) {
            heightNumber = windowWidth > 640 ? [290, 290] : [110, 110]
        }

        return {
            itemsLength: images.length,
            getDataByOnClick: getImageData,
            rootData: rootData,
            gapX: 0,
            gapY: 0,
            heights: heightNumber,
            images: images,
        };
    }


    return (
        <div
            className="fixed sm:flex items-center justify-center z-50 inset-0 create_post_modal" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div className="h-screen w-full flex items-center justify-center text-center sm:block sm:p-0">
                <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-all" aria-hidden="true" />
                <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                <motion.div
                    animate={showEditModal ? "open" : "closed"}
                    initial={{ scale: 0.7 }}
                    variants={{
                        open: { scale: 1 },
                        closed: { scale: 0.9 },
                    }}
                    exit={{ scale: 0 }}
                    transition={{ duration: 0.1 }}
                    ref={editModalRef}
                    className="relative inline-block bg-white dark:bg-[#292757] sm:rounded-xl text-left shadow-2xl
                                        transition-all
                                        align-center sm:align-middle
                                        p-3 sm:p-7
                                        h-full sm:h-auto
                                        w-full sm:w-9/12 md:max-w-xl xl:max-w-2xl overflow-auto
                                       ">

                    <div className="flex justify-between items-center">
                        <div className="relative inline-block">
                            <h1 className="xs:text-2xl xl:text-3xl mr-3 font-extrabold text-cusBlack dark:text-white">Edit Post</h1>
                            <div className="bottom-1 absolute -right-2.5">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={12} height={12} viewBox="0 0 12 12">
                                    <defs>
                                        <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                            <stop offset={0} stopColor="#00dbff" />
                                            <stop offset="0.529" stopColor="#e315e8" />
                                            <stop offset={1} stopColor="#ffd817" />
                                        </linearGradient>
                                    </defs>
                                    <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                                </svg>
                            </div>
                        </div>

                        <motion.button
                            whileTap={{ scale: 1 }}
                            whileHover={{ scale: 1.2 }}
                            transition={{ duration: 0.1 }}
                            onClick={() => setShowEditModal({ isOpen: false, postID: -1 })}
                            className="border border-gray-400 hover:bg-gray-300 dark:hover:bg-cusGray transition-all rounded-full p-2.5">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                                <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                            </svg>
                        </motion.button>
                    </div>

                    <div className="border-b border-[#e9e9e9] dark:border-[#35326a] mt-4"></div>

                    {editPostData &&
                        <div className=" overflow-y-auto sm:overflow-y-auto sm:max-h-[490px]">
                            <div className="flex justify-start items-center mt-3">
                                <NavLink to="/profile/activity">
                                    <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-full overflow-hidden">
                                        <img src={my_profile} alt="" className="w-full h-full" />
                                    </div>
                                </NavLink>
                                <div className="ml-3">
                                    <h5 className="text-cusBlack dark:text-white font-bold text-sm sm:text-base">Donald Trump</h5>


                                    <button type="button" className="px-2.5 py-1 bg-[#e6e8ec] dark:bg-[#e6e8ec20] rounded-md mt-1 transition-all cursor-pointer relative text-left"
                                        onClick={() => setPostVisibilityDropOpen(!postVisibilityDropOpen)}>
                                        <div className="flex justify-between items-center break-all">
                                            <h4 className="text-l-LightBlack dark:text-white font-semibold text-xs md:text-sm ">{postVisibilityText}</h4>
                                            <svg xmlns="http://www.w3.org/2000/svg" className={`h-3 w-3 blackWhiteSVG3 ml-2 transition-all ${postVisibilityDropOpen && 'rotate-180'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={4}>
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                            </svg>
                                        </div>
                                        {postVisibilityDropOpen &&
                                            <motion.div
                                                animate={postVisibilityDropOpen ? "open" : "closed"}
                                                initial={{ y: -15, }}
                                                variants={{
                                                    open: { y: 0, },
                                                    closed: { y: -100, },
                                                }}
                                                transition={{ duration: 0.2 }}
                                                ref={postVisibilityRef}
                                                className="rounded-lg overflow-hidden absolute top-7 bg-white dark:bg-[#292757] shadow-lg
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] w-full left-0 z-20">
                                                {["Public", "Only me", "Friends"].map(item =>
                                                    <div onClick={() => { setPostVisibilityText(item) }}
                                                        className="py-2.5 px-3 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all" key={item}>
                                                        <p className="text-cusBlack dark:text-white text-xs lg:text-sm font-medium">{item}</p>
                                                    </div>
                                                )}
                                            </motion.div>}
                                    </button>
                                </div>
                            </div>

                            <div className="flex mt-5">
                                <textarea
                                    name=""
                                    id="writeCommentBoxInput"
                                    defaultValue={editPostData!.postText || ''}
                                    className={`bg-transparent
                                                    ${isPhotoVideoOpen
                                            ? 'mb-2.5 min-h-[0px]'
                                            : 'min-h-[120px] sm:min-h-[130px] md:min-h-[150px] overflow-auto'}
                                                    pr-4 w-full outline-none text-cusBlack dark:text-white pl-1 resize-none
                                                    ${isChangeInputFontSize ? 'xs:text-sm sm:text-base' : 'xs:text-base sm:text-2xl'}`}

                                    onInput={handleCreatePostInputOnChange}
                                    spellCheck="false"
                                    placeholder='Write something here...'
                                    style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                                />
                            </div>


                            <div className="w-full mt-2 mb-3">
                                <p className="text-xs xsm:text-sm sm:text-base md:text-lg font-semibold text-cusBlack dark:text-white">Select Post Type:</p>

                                <div className="lightBlueBg mt-1 rounded-md sm:rounded-lg relative flex items-center overflow-hidden lavels_radios_box w-full">
                                    {editPostData?.postType?.toLowerCase() === "buynow"
                                        ? <input
                                            defaultChecked
                                            type="radio"
                                            onClick={() => setPostType('buynow')}
                                            name="postTypeSelect"
                                            id="postType_BuyNow"
                                            className="lavelsRadios" />

                                        : <input
                                            type="radio"
                                            onClick={() => setPostType('buynow')}
                                            name="postTypeSelect"
                                            id="postType_BuyNow"
                                            className="lavelsRadios" />}
                                    <label htmlFor="postType_BuyNow" className="border-r border-[#00000030]
                                                        dark:border-[#474383] text-cusBlack dark:text-cusBlueWhite w-full
                                                        px-1 xsm:px-4 py-2 sm:px-6 sm:py-3 text-center cursor-pointer
                                                         text-xxs xsm:text-sm lg:text-base whitespace-nowrap truncate
                                                        ">
                                        Buy now
                                    </label>

                                    {editPostData?.postType?.toLowerCase() === "stakenow"
                                        ? <input
                                            defaultChecked
                                            type="radio"
                                            onClick={() => setPostType('stakenow')}
                                            name="postTypeSelect"
                                            id="postType_stakeNow"
                                            className="lavelsRadios" />
                                        : <input
                                            type="radio"
                                            onClick={() => setPostType('stakenow')}
                                            name="postTypeSelect"
                                            id="postType_stakeNow"
                                            className="lavelsRadios" />

                                    }
                                    <label htmlFor="postType_stakeNow" className="border-r border-[#00000030] 
                                                        dark:border-[#474383] text-cusBlack dark:text-cusBlueWhite w-full
                                                        px-1 xsm:px-4 py-2 sm:px-6 sm:py-3 text-center cursor-pointer
                                                         text-xxs xsm:text-sm lg:text-base whitespace-nowrap truncate
                                                        ">
                                        Stake now
                                    </label>


                                    {editPostData?.postType?.toLowerCase() === "mintnow"
                                        ? < input
                                            defaultChecked
                                            type="radio"
                                            onClick={() => setPostType('mintnow')}
                                            name="postTypeSelect"
                                            id="postType_mintNow"
                                            className="lavelsRadios" />
                                        : <input
                                            type="radio"
                                            onClick={() => setPostType('mintnow')}
                                            name="postTypeSelect"
                                            id="postType_mintNow"
                                            className="lavelsRadios" />
                                    }
                                    <label htmlFor="postType_mintNow" className="border-r border-[#00000030] 
                                                        dark:border-[#474383] text-cusBlack dark:text-cusBlueWhite w-full
                                                        px-1 xsm:px-4 py-2 sm:px-6 sm:py-3 text-center cursor-pointer
                                                         text-xxs xsm:text-sm lg:text-base whitespace-nowrap truncate
                                                        ">
                                        Mint now
                                    </label>


                                    {editPostData?.postType?.toLowerCase() === "auction"
                                        ? <input
                                            defaultChecked
                                            type="radio"
                                            onClick={() => setPostType('auction')}
                                            name="postTypeSelect"
                                            id="postType_auction"
                                            className="lavelsRadios" />
                                        : <input
                                            type="radio"
                                            onClick={() => setPostType('auction')}
                                            name="postTypeSelect"
                                            id="postType_auction"
                                            className="lavelsRadios" />
                                    }
                                    <label htmlFor="postType_auction" className="text-cusBlack dark:text-cusBlueWhite
                                                        w-full px-1 xsm:px-4 py-2 sm:px-6 sm:py-3 text-center cursor-pointer
                                                         text-xxs xsm:text-sm lg:text-base whitespace-nowrap truncate
                                                        ">
                                        Auction
                                    </label>
                                </div>


                            </div>



                            {isPhotoVideoOpen &&
                                <div>
                                    {
                                        uploadedImageFile
                                            ? <div className="border-2 rounded-lg border-[#e9e9e9] dark:border-[#484485] p-2 mb-4 photo_grid_box relative">
                                                <button onClick={() => setUploadedImageFile(null)}
                                                    title="Close All" className="w-9 h-9 rounded-full bg-[#00000050] border border-[#ffffff40] absolute z-10 right-5 top-5
                                                                 flex justify-center items-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="#fff">
                                                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                                    </svg>
                                                </button>
                                                <PostGrid propObject={getPostGridPorps(uploadedImageFile, uploadedImageFile)} />
                                                {/* {memoizePostGrid} */}
                                            </div>

                                            : <div {...getRootProps({ className: 'uploadCreatePostImages' })}
                                                className="border-2 rounded-lg border-[#e9e9e9] dark:border-[#484485] p-2 mb-4">
                                                <input  {...getInputProps()} type="file" name="" id="" />
                                                <div className="bg-[#efefef] hover:bg-[#dadada] dark:bg-[#363375] dark:hover:bg-[#3f3d88] p-7 rounded-lg
                                                                cursor-pointer transition-all h-[170px] sm:h-[250px] flex justify-center items-center">
                                                    <div className="flex flex-col justify-center items-center">
                                                        <svg id="File" xmlns="http://www.w3.org/2000/svg" className="w-9 h-9" viewBox="0 0 21.25 19.595">
                                                            <circle className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Oval" cx="1.357" cy="1.357" r="1.357" transform="translate(9.054 3.595)" fill="" />
                                                            <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Shape" d="M12.221,19.595H12.03l-9.619-.666a2.567,2.567,0,0,1-2.4-2.762L.959,2.4A2.638,2.638,0,0,1,3.554,0h.191L13.34.69A2.6,2.6,0,0,1,15.768,3.4l-.547,7.762-.428,6a2.569,2.569,0,0,1-.881,1.786A2.487,2.487,0,0,1,12.221,19.595Zm-8.1-9.214-2.69,2.167-.262,3.69a1.412,1.412,0,0,0,1.309,1.5l9.618.667h.1a1.433,1.433,0,0,0,.929-.334,1.331,1.331,0,0,0,.476-.952l.428-5.738-2.857-3.31-4.31,3.6.619.69a.581.581,0,0,1,.146.426.59.59,0,0,1-.194.408.649.649,0,0,1-.405.143.556.556,0,0,1-.452-.191Zm-.548-9.19A1.407,1.407,0,0,0,2.174,2.5l-.6,8.452L3.864,9.119a.586.586,0,0,1,.365-.127.6.6,0,0,1,.445.2l1.382,1.571L10.84,6.786a.59.59,0,0,1,.377-.137.617.617,0,0,1,.457.208L14.15,9.69,14.6,3.357a1.412,1.412,0,0,0-1.31-1.5L3.673,1.191Z" transform="translate(5.476)" fill="" />
                                                            <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Path" d="M2.483,1.452l2.667-.214A3.888,3.888,0,0,1,5.816,0L2.387.286a2.556,2.556,0,0,0-1.762.9A2.579,2.579,0,0,0,.007,3.071L1.1,16.81a2.556,2.556,0,0,0,.9,1.762,2.582,2.582,0,0,0,1.667.619h.214L5.1,19.1l-.143-.143a4.931,4.931,0,0,1-.643-.976l-.548.048a1.428,1.428,0,0,1-1.524-1.286L1.149,3A1.462,1.462,0,0,1,2.483,1.452Z" transform="translate(0 0.095)" fill="" />
                                                        </svg>
                                                        <p className="text-l-LightBlack dark:text-cusBlueWhite font-semibold text-sm sm:text-base md:text-lg mt-3">Upload Photo/Video</p>
                                                        <p className="text-l-LightBlack dark:text-cusBlueWhite text-xxs sm:text-xs md:text-sm">or, drag and drop here</p>
                                                    </div>
                                                </div>
                                            </div>
                                    }
                                </div>
                            }


                            <div className="border-2 mt-2 border-[#e9e9e9] dark:border-[#484485] p-1 rounded-lg flex justify-between items-center">

                                <p className="text-cusBlack dark:text-white pl-4 text-sm sm:text-base">Add to your post </p>

                                <button
                                    onClick={() => setIsPhotoVideoOpen(!isPhotoVideoOpen)}
                                    className={`flex justify-center items-center hover:bg-[#dadada] dark:hover:bg-[#48448d] px-3 sm:px-5 py-2 rounded-lg
                                                    ${isPhotoVideoOpen ? 'bg-[#dadada] dark:bg-[#48448d]' : ''}`}>
                                    <svg id="File" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 sm:w-7 sm:h-7" viewBox="0 0 21.25 19.595">
                                        <circle className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Oval" cx="1.357" cy="1.357" r="1.357" transform="translate(9.054 3.595)" fill="" />
                                        <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Shape" d="M12.221,19.595H12.03l-9.619-.666a2.567,2.567,0,0,1-2.4-2.762L.959,2.4A2.638,2.638,0,0,1,3.554,0h.191L13.34.69A2.6,2.6,0,0,1,15.768,3.4l-.547,7.762-.428,6a2.569,2.569,0,0,1-.881,1.786A2.487,2.487,0,0,1,12.221,19.595Zm-8.1-9.214-2.69,2.167-.262,3.69a1.412,1.412,0,0,0,1.309,1.5l9.618.667h.1a1.433,1.433,0,0,0,.929-.334,1.331,1.331,0,0,0,.476-.952l.428-5.738-2.857-3.31-4.31,3.6.619.69a.581.581,0,0,1,.146.426.59.59,0,0,1-.194.408.649.649,0,0,1-.405.143.556.556,0,0,1-.452-.191Zm-.548-9.19A1.407,1.407,0,0,0,2.174,2.5l-.6,8.452L3.864,9.119a.586.586,0,0,1,.365-.127.6.6,0,0,1,.445.2l1.382,1.571L10.84,6.786a.59.59,0,0,1,.377-.137.617.617,0,0,1,.457.208L14.15,9.69,14.6,3.357a1.412,1.412,0,0,0-1.31-1.5L3.673,1.191Z" transform="translate(5.476)" fill="" />
                                        <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Path" d="M2.483,1.452l2.667-.214A3.888,3.888,0,0,1,5.816,0L2.387.286a2.556,2.556,0,0,0-1.762.9A2.579,2.579,0,0,0,.007,3.071L1.1,16.81a2.556,2.556,0,0,0,.9,1.762,2.582,2.582,0,0,0,1.667.619h.214L5.1,19.1l-.143-.143a4.931,4.931,0,0,1-.643-.976l-.548.048a1.428,1.428,0,0,1-1.524-1.286L1.149,3A1.462,1.462,0,0,1,2.483,1.452Z" transform="translate(0 0.095)" fill="" />
                                    </svg>
                                    <p className="hidden sm:block  text-l-LightBlack dark:text-cusBlueWhite ml-2.5 font-semibold">Photo/Video</p>
                                </button>
                            </div>
                        </div>


                    }

                    <motion.button
                        whileTap={{ scale: 0.9 }}
                        transition={{ duration: 0.1 }}
                        onClick={hanldePostEditSubmit}
                        className={`${createPostInputText.length > 1
                            ? 'gradientBtn text-white'
                            : 'bg-gray-100 dark:bg-gray-500 text-gray-300 dark:text-gray-700 cursor-not-allowed'}
                                             w-full mt-3 p-2 sm:p-3 rounded-lg font-semibold`}>
                        Save Now
                    </motion.button>



                </motion.div>
            </div>
        </div>
    );
}
